import { render, staticRenderFns } from "./PaperSubmit.vue?vue&type=template&id=311338e6&scoped=true&"
import script from "./PaperSubmit.vue?vue&type=script&lang=js&"
export * from "./PaperSubmit.vue?vue&type=script&lang=js&"
import style0 from "./PaperSubmit.vue?vue&type=style&index=0&id=311338e6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "311338e6",
  null
  
)

export default component.exports